import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import LocalizedLink from '../components/common/LocalizedLink';
import SEO from '../components/common/SEO';
import { useLanguage } from '../contexts/LanguageContext';

const { FiHome, FiSearch } = FiIcons;

const content = {
  en: {
    title: 'Page Not Found | Pet Care Note',
    description: 'The requested Pet Care Note page could not be found.',
    heading: 'Page not found',
    message: 'The page may have moved, expired, or never existed.',
    action: 'Back to home'
  },
  zh: {
    title: '找不到頁面 | Pet Care Note',
    description: '找不到您要求的 Pet Care Note 頁面。',
    heading: '找不到頁面',
    message: '此頁面可能已移動、失效或不存在。',
    action: '返回首頁'
  },
  ja: {
    title: 'ページが見つかりません | Pet Care Note',
    description: 'お探しの Pet Care Note ページが見つかりません。',
    heading: 'ページが見つかりません',
    message: 'ページが移動、削除されたか、存在しない可能性があります。',
    action: 'ホームへ戻る'
  }
};

const NotFoundPage = () => {
  const { language } = useLanguage();
  const text = content[language] || content.en;

  return (
    <>
      <SEO
        title={text.title}
        description={text.description}
        noindex={true}
      />
      <div className="min-h-[calc(100vh-5rem)] bg-gradient-to-br from-neutral-50 to-primary-50/30 px-4 pt-28 pb-16 flex items-center justify-center">
        <div className="max-w-xl w-full text-center">
          <div className="w-24 h-24 mx-auto mb-8 rounded-3xl bg-primary-100 text-primary-600 flex items-center justify-center shadow-sm">
            <SafeIcon icon={FiSearch} className="w-11 h-11" />
          </div>
          <p className="text-sm font-bold tracking-[0.3em] text-primary-600 uppercase mb-4">
            Error 404
          </p>
          <h1 className="text-4xl sm:text-5xl font-bold text-neutral-900 mb-5">
            {text.heading}
          </h1>
          <p className="text-lg text-neutral-600 leading-relaxed mb-8">
            {text.message}
          </p>
          <LocalizedLink
            to="/"
            className="inline-flex items-center justify-center px-7 py-3.5 bg-primary-600 text-white font-semibold rounded-xl shadow-lg hover:bg-primary-700 hover:shadow-xl transition-all duration-300"
          >
            <SafeIcon icon={FiHome} className="w-5 h-5 mr-2" />
            {text.action}
          </LocalizedLink>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;